import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MatOption } from '@angular/material';
import * as Highcharts from 'highcharts';
import { Router } from '@angular/router';
import { DashboardService } from '../dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { HighchartsService } from '../highchart.service';
import { DatePipe } from '@angular/common';
import * as jspdf from 'jspdf';
import 'jspdf-autotable';
@Component({
  selector: 'app-wms-report',
  templateUrl: './wms-report.component.html',
  styleUrls: ['./wms-report.component.scss']
})
export class WmsReportComponent implements OnInit {
  @ViewChild('allSelected', { static: false }) private allSelected: MatOption;
  @ViewChild('allSelected1', { static: false }) private allSelected1: MatOption;
  @ViewChild('charts', { static: false }) chartEl: ElementRef;

  pipe = new DatePipe('en-US')
  private ResponseinverterList: Subject<any> = new Subject();
  public graphForm: FormGroup;
  public reportDownloadForm: FormGroup;
  Highcharts = Highcharts;
  public inverterList: any[];
  data_Day: any = [{ name: '', data: [] }];
  graphDetailsArray: any;
  graphRequestObject: any = {};
  custom = false;
  yaxis: any = [];
  device_Info: any = [];
  public subDevice_id: any;
  public serial_no: any;
  updateFlag: boolean;
  categories_Day: any[];
  minDate = new Date(2017, 1, 1);
  maxDate = new Date();
  fileType_Pdf: boolean;
  fileType_Csv: boolean;
  myOptions: {
    chart: { type: string; }; tooltip: { shared: boolean, }; title: { text: string; }; xAxis: { categories: any[]; }; yAxis: []; legend: { reversed: boolean; }; plotOptions: { series: { stacking: string; }; }; series: [], exporting: {};
  };
  //   chartOptions = {
  //     chart: {
  //       type: 'spline'
  //     },
  //     title: {
  //       text: 'water use'
  //     },
  //     subtitle: {
  //       text: ''
  //     },
  //     xAxis: {
  //       categories: ['5.00', '5.30', '6.00', '6.30', '7.00', '7.30',
  //         '8.00', '8.30', '9.00', '9.30', '10.00', '10.30', '11.00',
  //         '11.30', '12.00', '12.30', '13.00', '13.30', '14.00', '14.30',
  //         '15.00', '15.30', '16.00', '16.30', '17.00', '17.30', '18.00',
  //         '18.30', '19.00', '19.30', '20.00']
  //     },
  //     yAxis: [{ // Primary yAxis
  //       labels: {
  //           style: {
  //               color: Highcharts.getOptions().colors[0]
  //           }
  //       },
  //       title: {
  //           text: 'Water Used Day 1',
  //           style: {
  //               color: Highcharts.getOptions().colors[0]
  //           }
  //       },


  //   },
  //   { // Secondary yAxis
  //     labels: {
  //         style: {
  //             color: Highcharts.getOptions().colors[1]
  //         }
  //     },
  //     title: {
  //         text: 'Water Used Day 2',
  //         style: {
  //             color: Highcharts.getOptions().colors[1]
  //         }
  //     },


  // },],
  //     tooltip: {
  //       valueSuffix: ''
  //     },
  //     series: [
  //       {
  //         name: 'Water Used Day 1',
  //         yAxis: 0,
  //         data: [0.0, 0.0, 0.0, 0.0, 1.17, 11.61, 4.3, 8.63, 14.44, 9.49, 5.1,
  //           25.91, 24.94, 17.22, 16.59, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
  //           0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]
  //       },
  //       {
  //         name: 'Water Used Day1',
  //         yAxis: 1,
  //         data: [1.0, 8.0, 7.0, 0.0, 3.17, 51.61, 6.3, 1.63, 10.44, 9.49, 7.1,
  //           2.91, 20.94, 16.22, 17.59, 1.0, 2.0, 7.0, 5.0, 3.0, 10.0, 3.0, 1.0, 10.0,
  //           20.0, 30.0, 0.0, 0.0, 0.0, 0.0, 0.0]
  //       },
  //     ]
  //   };
  public baseURL: any;
  public epcId: any;
  public role: any;
  public roleName: string;
  public parameterList: any = [];
  parameterListObj: {};
  csvFlag = false;
  yearGraphFlag = false;
  csvMonthFlag = false;
  public myFormattedDate: any;
  public authToken = localStorage.loginToken;
  public loginName = localStorage.login_id;
  public myFormattedMonth: any;
  public FormattedYear: any;
  public myFormattedYear: any;
  tabselection: any;
  constructor(private toastr: ToastrService, private highchart: HighchartsService, private fb: FormBuilder, private router: Router, private dashboardService: DashboardService) {

    this.epcId = localStorage.id;
    this.baseURL = environment.apiBase;
    this.role = localStorage.role;
    if (this.role === '1') {
      this.roleName = 'admin';
    } else if (this.role === '2') {
      this.roleName = 'epc';
    } else if (this.role === '3') {
      this.roleName = 'wms';
    } else if (this.role === '4') {
      this.roleName = 'normal';
    }


  }

  ngOnInit() {
    Highcharts.setOptions({
      lang: {
        decimalPoint: '.',
        thousandsSep: ''
      }
    });
 this.tabselection = 'parameter_trends'
    this.graphForm = this.fb.group({
      inverter_id: ['', Validators.required],
      parameter_id: ['', Validators.required],
      ToDate: ['', Validators.required],
      FromDate: ['', Validators.required],
      timewindow: ['', Validators.required]
    });

    this.reportDownloadForm = this.fb.group({
      dayDate: ['', Validators.required],
      monthYear: ['', Validators.required],
      year: ['', Validators.required],
      inverter_csv: ['', Validators.required],
      inverter_date: ['', Validators.required]
    });
    this.getInverterList()
  }
  get f() { return this.reportDownloadForm.controls; }
  showParameterTrendsTab(tab){
    this.tabselection=tab;
      }
      showDownloadReportab(tab){
        this.tabselection=tab;
      }

  // select all DropDown in parameter List
  toggleAllSelection() {
    if (this.allSelected.selected) {
      this.graphForm.controls.parameter_id
        .patchValue([...this.parameterList.map(item => item), 0]);
      var last = this.graphForm.value.parameter_id.pop();
    } else {
      this.graphForm.controls.parameter_id.patchValue([]);
    }
  }
  tosslePerOne(all){
    if (this.allSelected.selected) {
     this.allSelected.deselect();
     return false;
 }

 }
   // select all DropDown in Inverter List
   selectAllInverter(value) {

    if (this.allSelected1.selected) {
      this.graphForm.controls.inverter_id
        .patchValue([...this.inverterList.map(item => item), 0]);
     this.graphForm.value.inverter_id.pop();
    } else
      this.graphForm.controls.inverter_id.patchValue([]);
    this.getParameterList();

}
onSelectOneInverter(all){
  if (this.allSelected1.selected) {
    this.allSelected1.deselect();
    return false;
}

this.getParameterList();

 }

   // select dropdown date, month, date
   onChangeDate(value) {
    if (value === 'day') {
      this.csvFlag = true;
      this.csvMonthFlag = false;
      this.yearGraphFlag = false;
    } else if (value === 'month') {
      this.csvFlag = false;
      this.csvMonthFlag = true;
      this.yearGraphFlag = false;
    } else if (value === 'year') {
      this.csvFlag = false;
      this.csvMonthFlag = false;
      this.yearGraphFlag = true;
    }
  }
  onChangeCsv(value) {
    if(value == '1'){
      this.fileType_Pdf= false;
    this.fileType_Csv= true;
    }else if(value == '2'){
      this.fileType_Csv= false;
      this.fileType_Pdf= true;
    }

  }
  // Select DropDown Of Time Window for wms User
  onChangeTimeWindow(value) {
    if (value === 'Today') {
      this.custom = false;
      this.graphForm.get('ToDate').setValue(new Date());
      this.graphForm.get('FromDate').setValue(new Date());
    } else if (value === 'Last 7 Days') {
      this.custom = false;
      const x = new Date(new Date().getTime() - (6 * 24 * 60 * 60 * 1000));
      this.graphForm.get('ToDate').setValue(new Date);
      this.graphForm.get('FromDate').setValue(x);
    } else if (value === 'Last 30 Day') {
      this.custom = false;
      const x = new Date(new Date().getTime() - (29 * 24 * 60 * 60 * 1000));
      this.graphForm.get('ToDate').setValue(new Date);
      this.graphForm.get('FromDate').setValue(x);
    } else if (value === 'Custom') {
      this.custom = true;
    }
  }

    // csv download today code
public csvDownloadToday() {
      const pipe = new DatePipe('en-US');
      this.myFormattedDate = pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd');
      window.location.href = this.baseURL + '/wms/Report/csvToday?date=' + this.myFormattedDate + '&user_id=' + this.loginName + '&Authorization=' + this.authToken;

    }
// csv download monthly code
public csvDownloadMonthly() {
  const pipe = new DatePipe('en-US');
  this.myFormattedMonth = pipe.transform(this.reportDownloadForm.value.monthYear, 'MM');
  this.FormattedYear = pipe.transform(this.reportDownloadForm.value.monthYear, 'yyyy');
  window.location.href = this.baseURL + '/wms/Report/csvMonth?month=' + this.myFormattedMonth + '&year=' + this.FormattedYear + '&user_id=' + this.loginName + '&Authorization=' + this.authToken;
}
  // csv download year
  public csvDownloadYear() {

    const pipe = new DatePipe('en-US');
    this.myFormattedYear = pipe.transform(this.reportDownloadForm.value.year, 'yyyy');
    window.location.href = this.baseURL + '/wms/Report/csvYear?year=' + this.myFormattedYear + '&user_id=' + this.loginName + '&Authorization=' + this.authToken;

  }

  public getInverterList() {
    this.dashboardService.getWmsInverterList()
      .pipe(takeUntil(this.ResponseinverterList))
      .subscribe(
        async result => {

          if (result.status) {
            this.inverterList = result.resultObject;
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // get Parameter list on drop Down for Normal User
  public getParameterList() {

    this.parameterListObj = {
      device_info: this.graphForm.controls.inverter_id.value,
    };
    this.dashboardService.getParamNoAndParamNameListOfWms(this.parameterListObj)
      .pipe(takeUntil(this.ResponseinverterList))
      .subscribe(
        async result => {
          this.parameterList = [];
          if (result.status) {
            this.parameterList = result.resultObject;
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  showGraph() {
    this.graphRequestObject = {
      from: this.pipe.transform(this.graphForm.controls['FromDate'].value, "yyyy-MM-dd"),
      to: this.pipe.transform(this.graphForm.controls['ToDate'].value, "yyyy-MM-dd"),
      dev:this.graphForm.controls.inverter_id.value,
      param: this.graphForm.value.parameter_id
    };
    this.dashboardService.getReportGraph(this.graphRequestObject)
      .pipe(takeUntil(this.ResponseinverterList))
      .subscribe(
        async data => {
          // const array = [];
          this.categories_Day = [];
           this.data_Day = [];
           this.graphDetailsArray = [];
          this.yaxis = [];
          if (data.status) {
            this.graphDetailsArray = data.resultObject.device;
            this.categories_Day = data.resultObject.timeStamp
            for (let p = 0; p <  this.graphDetailsArray.length; p++) {
              if (p % 2 == 0) {
                var opposite = true
              } else {
                opposite = false
              }
                if(opposite){
                  this.yaxis.push({ // Primary yAxis
                    lineWidth: 1,
                    margin: -15,
                    labels: {
                      x: 5,
                      y: 5,
                      rotation: -90,
                      style: {
                        fontSize: '8px',
                        color: Highcharts.getOptions().colors[p]
                      }
                    },
                    title: {
                      text:this.graphDetailsArray[p].inv_name+" " +this.graphDetailsArray[p].param_name,
                      x: -15,
                      style: {
                        color: Highcharts.getOptions().colors[p]
                      }
                    },

                    opposite: opposite,
                  });

                }else{
                  this.yaxis.push({ // Primary yAxis
                    lineWidth: 1,
                    margin: -15,
                    labels: {
                      x: -5,
                      y: -5,
                      rotation: -90,
                      style: {
                        fontSize: '8px',
                        color: Highcharts.getOptions().colors[p]
                      }
                    },
                    title: {
                      text:this.graphDetailsArray[p].inv_name+" " +this.graphDetailsArray[p].param_name ,
                      x: 15,
                      style: {
                        color: Highcharts.getOptions().colors[p]
                      }
                    },
                  });

                }

              // set the graph serise
                this.data_Day.push({
                  name: this.graphDetailsArray[p].inv_name+" " +this.graphDetailsArray[p].param_name,
                  yAxis: p,
                  data:this.graphDetailsArray[p].data
                });

              this.updateFlag = true;
            }
            this.myOptions = {
              chart: {
                type: 'spline'
              }, tooltip:
              {
                shared: true,

              },
              title: {
                text: ''
              },
              xAxis: {
                categories:  this.categories_Day,
              },
              yAxis: this.yaxis,
              legend: {
                reversed: true
              },
              plotOptions: {
                series: {
                  stacking: 'normal'
                }
              },
              series: this.data_Day,
              exporting: {
                buttons: {
                  contextButton: {
                    menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
                  }
                }
              }
            };
            this.highchart.createChart(this.chartEl.nativeElement, this.myOptions);

          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);
              this.data_Day = [];
              this.categories_Day = [];
              this.myOptions = {
                chart: {
                  type: 'spline'
                }, tooltip:
                {
                  shared: true,
                },

                title: {
                  text: ''
                },
                xAxis: {
                  categories: this.categories_Day
                },
                yAxis: this.yaxis,
                legend: {
                  reversed: true
                },
                plotOptions: {
                  series: {
                    stacking: 'normal'
                  }
                },
                series: this.data_Day,
                exporting: {
                  buttons: {
                    contextButton: {
                      menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
                    }
                  }
                }
              };
              this.highchart.createChart(this.chartEl.nativeElement, this.myOptions);

            }


          }
        },
        err => {

          return console.error(err);

        }
      );
  }
  download_DayPdf() {
    var UserIdObj ={
      date : this.pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd'),
      user_id:this.loginName
    }
      this.dashboardService.downloadWmsTodaysPdf(UserIdObj)
        .subscribe(
          async data => {
            if (data.status) {
              var responseData = data.resultObject;
              var b64image = JSON.stringify(responseData.epc_b64image);
                // remove quated string
                 var base64Img =  b64image.replace(/"/g, '');
              var doc = new jspdf('l', 'pt', 'a4'); //landscape page
              doc.autoTableSetDefaults({
                didDrawPage: function(data) {
                  doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                  doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                  doc.text("Solar generation Daily Report", data.settings.margin.left + 550, 22);
                  doc.setDrawColor(31,78,121);
                  doc.line(0, 45, 900, 45);
                },
                margin: {
                  top: 60,
                  bottom: 50
                },
            })
              if(responseData.customer){
                var demo = []
                demo.push(responseData.customer)
                doc.autoTable({
                  body: demo,
                  columns: [{ header: 'Customer Name', dataKey: 'customer_name' }, { header: 'Plant Capacity (KW)',
                    dataKey: 'plant_capacity' }, { header: 'Address', dataKey: 'address' }, {header: 'Date',dataKey: 'date' }]
                })
              }
              if(responseData.energy_generation){
                var demo1 = []
                demo1.push(responseData.energy_generation)
                doc.autoTable({
                  body: demo1,
                  columns: [{ header: 'Daily Energy Generation (KWh)', dataKey: 'daily_energy_generation' },
                   { header:'Total Energy Generation (KWh/MWh)',dataKey: 'total_energy_generation' },
                   { header:'Insolation (KWh/m2)',dataKey: 'insolation' },
                   { header:'Pr (%)',dataKey: 'pr' },
                   { header:'Specific Yeild (KWh/KWp)',dataKey: 'specific_yeild' },
                  ]
                })
              }
              if(responseData.generationArr){
                doc.autoTable({
                  body: responseData.generationArr,
                  columns: [{ header: 'Inverter Name', dataKey: 'inverter_name' },
                  { header: 'Daily Energy Generation (KWh)', dataKey: 'daily_energy_generation' },
                  { header: 'Total Energy Generation (KWh/MWh)', dataKey: 'total_energy_generation' },
                  { header: 'Specific Yield (KWh/KWp)', dataKey: 'specific_yield' }]
                })
              }


              doc.save(responseData.title+'.pdf');
              this.toastr.success(data.message);
            }  else if (!data.status) {
              if (data.message == 'Unauthorised or Login Time-out') {
                this.toastr.info(data.message);
                this.router.navigate(["/login"]);

              } else {
                this.toastr.info(data.message);

              }

            }
          },
          err => {
            return console.error(err);
          }
        );
    }
    download_MonthPdf() {
      var UserIdObj ={
        month : this.pipe.transform(this.reportDownloadForm.value.monthYear, 'MM'),
        year : this.pipe.transform(this.reportDownloadForm.value.monthYear, 'yyyy'),
        user_id:this.loginName
      }
        this.dashboardService.downloadWmsMonthPdf(UserIdObj)
          .subscribe(
            async data => {
              if (data.status) {
                var responseData = data.resultObject;
                var b64image = JSON.stringify(responseData.epc_b64image);
                // remove quated string
                 var base64Img =  b64image.replace(/"/g, '');
                var doc = new jspdf('l', 'pt', 'a4'); //landscape page
                doc.autoTableSetDefaults({
                  didDrawPage: function(data) {
                    doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                    doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                    doc.text("Solar generation Monthly Report", data.settings.margin.left + 535, 22);
                    doc.setDrawColor(31,78,121);
                    doc.line(0, 45, 900, 45);
                  },
                  margin: {
                    top: 60,
                    bottom: 50
                  },


              })
                if(responseData.customer){
                  var demo = []
                  demo.push(responseData.customer)
                  doc.autoTable({

                    body: demo,
                    columns: [{ header: 'Customer Name', dataKey: 'customer_name' }, { header:'Plant Capacity (KW)',dataKey: 'plant_capacity' },
                    { header: 'Address', dataKey: 'address' }, { header: 'Date',dataKey: 'month' }]
                  })
                }
               if(responseData.energy_generation){
                var demo1 = []
                demo1.push(responseData.energy_generation)
                doc.autoTable({
                  body: demo1,
                  columns: [{ header: 'Total Month Energy (KWh)', dataKey: 'total_month_energy' },
                  { header: 'Average Pr (%)', dataKey: 'average_pr' },
                   { header: 'Average Insolation (KWh/m2)',dataKey: 'average_insolation' },
                   { header:'Specific Yeild (KWh/KWp)',dataKey: 'specific_yeild' },
                  ]
                })
               }


                if(responseData.header){
                  var headerArr = [];
                  headerArr = Object.keys(responseData.header).map(function (key) {
                    return [String(key), responseData.header[key]];
                  });

                  var dynamicColArr = [];
                  for (let i = 0; i < headerArr.length; i++) {
                    var key = headerArr[i][1];
                    dynamicColArr.push({ header: key, dataKey: "value" + i })
                  }
                  doc.autoTable({
                    body: responseData.generationArr,
                    columns: dynamicColArr
                  })
                }
                doc.save(responseData.title+".pdf");
                this.toastr.success(data.message);
              }  else if (!data.status) {
                if (data.message == 'Unauthorised or Login Time-out') {
                  this.toastr.info(data.message);
                  this.router.navigate(["/login"]);

                } else {
                  this.toastr.info(data.message);

                }

              }
            },
            err => {
              return console.error(err);
            }
          );
      }
      download_YearPdf() {
        var UserIdObj ={
          year : this.pipe.transform(this.reportDownloadForm.value.year, 'yyyy'),
          user_id:this.loginName
        }
          this.dashboardService.downloadWmsYearPdf(UserIdObj)
            .subscribe(
              async data => {
                if (data.status) {
                  var responseData = data.resultObject;
                  var b64image = JSON.stringify(responseData.epc_b64image);
                  // remove quated string
                   var base64Img =  b64image.replace(/"/g, '');
                  var doc = new jspdf('l', 'pt', 'a4'); //landscape page
                  doc.autoTableSetDefaults({
                    didDrawPage: function(data) {
                      doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                      doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                      doc.text("Solar generation Yearly Report", data.settings.margin.left + 545, 22);
                      doc.setDrawColor(31,78,121);
                      doc.line(0, 45, 900, 45);
                    },
                    margin: {
                      top: 60,
                      bottom: 50
                    },
                })

                  if(responseData.customer){
                    var demo = []
                    demo.push(responseData.customer)
                    doc.autoTable({

                      body: demo,
                      columns: [{ header: 'Customer Name', dataKey: 'customer_name' }, { header:'Plant Capacity (KW)',dataKey: 'plant_capacity' },
                      { header: 'Address', dataKey: 'address' }, { header: 'Year',dataKey: 'year' }]
                    })
                  }
                 if(responseData.energy_generation){
                  var demo1 = []
                  demo1.push(responseData.energy_generation)
                  doc.autoTable({
                    body: demo1,
                    columns: [{ header: 'Total Year Energy (KWh)', dataKey: 'total_month_energy'},
                    { header: 'Average Pr (%)', dataKey: 'average_pr'},
                    { header: 'Average Insolation (KWh/m2)',dataKey: 'average_insolation'},
                    { header: 'Specific Yeild (KWh/KWp)',dataKey: 'specific_yeild'},
                  ]
                  })
                 }


                  if(responseData.header){
                    var headerArr = [];
                    headerArr = Object.keys(responseData.header).map(function (key) {
                      return [String(key), responseData.header[key]];
                    });

                    var dynamicColArr = [];
                    for (let i = 0; i < headerArr.length; i++) {
                      var key = headerArr[i][1];
                      dynamicColArr.push({ header: key, dataKey: "value" + i })
                    }
                    doc.autoTable({
                      body: responseData.generationArr,
                      columns: dynamicColArr
                    })
                  }
                  doc.save(responseData.title+".pdf");
                  this.toastr.success(data.message);
                }  else if (!data.status) {
                  if (data.message == 'Unauthorised or Login Time-out') {
                    this.toastr.info(data.message);
                    this.router.navigate(["/login"]);

                  } else {
                    this.toastr.info(data.message);

                  }

                }
              },
              err => {
                return console.error(err);
              }
            );
        }
  ngOnDestroy() {
    this.ResponseinverterList.next();
    this.ResponseinverterList.complete();
  }
}
